export const CONTENT_SUBMISSION_FILE_TYPES = ["application/pdf", "audio/wav", "audio/mpeg"];
